import 'rxjs/add/operator/filter';

import module from 'module';
const templateUrl = require('./roles-list.template.html');

module.component('rolesList', {
  templateUrl,
  bindings: {
      // List of roles
      'roles': '=',
    },
  controller: function($scope, $location, rolesCache, http, notification, confirmation, command) {
    const that = this;
    const baseUrl = '/admin/security/roles/';
    that.header = [];

    that.openRole = (index) => {
        let redirectionUrl = baseUrl.concat(that.roles[index].id);
        $location.path(redirectionUrl);
    };

    that.addRole = () => {
      that.roles.push({dirty: true});
    };

    that.cancelAddRole = index => {
      that.roles.splice(index, 1);
    };

    that.isSaveDisabled = index => !that.roles[index].name;

    that.saveRole = index => {
      if(that.roles[index].name) {
        confirmation('Do you want to save the role?', () => {
          http.post('/management/roles', {
            name: that.roles[index].name,
            technical: false,
            cashierCounter: that.roles[index].cashierCounter
          }, {nxLoaderText: 'Saving role'}).success(response => {
            rolesCache.evict();
            notification.show("Role has been saved.");
            that.roles[index].dirty = false;
            that.roles[index].id = response.id;
          })
        });
      }
    };

    that.deleteRole = index => {
      confirmation(`Do you want to remove role ${that.roles[index].name}?`, () => {
        command.execute('DeleteRole', { id: that.roles[index].id }).success(ok => {
          rolesCache.evict();
          notification.show('Role has been removed.');
          that.roles.splice(index, 1);
        });
      });
    };
  }
});